<template>
  <div style="line-height: 20px; overflow: auto; height: inherit;">
    <b>Müşteri => </b>{{params.data.customerName}} <br><b>Personel => </b>{{params.data.userName}} <br><b>Ürün => </b>{{params.data.productName}}
    <br><b>Seri No 1 => </b>{{params.data.serialCode1?params.data.serialCode1:" Yok"}}<br><b> Seri No 2 => </b>{{params.data.serialCode2?params.data.serialCode2:" Yok"}} <br><b>Açıklama => </b>{{params.data.description?params.data.description:" Yok"}}
    <br><b>Mail Konusu => </b>{{params.data.mailSubject?params.data.mailSubject: " Yok"}}<br><b> Mail İçerik => </b>{{params.data.mailBody?params.data.mailBody: " Yok"}} <br><b> Email => </b>{{params.data.eMail?params.data.eMail: " Yok"}}
    <br><b>Ana Mail => </b>{{params.data.masterEmail?params.data.masterEmail: "Yok" }}<br><b> Adres => </b>{{params.data.address}}
    <br><b>Telefon => </b>{{params.data.phone}}<br><b> TCKN / VKN => </b>{{params.data.taxNumber}}
  </div>
</template>

<script>
export default {
  name: "CellRendererDetail",
  data() {
    return {
      subscriptionList: "",
      span: "",
    };
  },
  computed: {},
  beforeMount() {},
};
</script>
